import { useQuery } from "react-query";
import { apiInstance } from "../config/baseUrl";


export const useSimpleFetch = (key, url) => {
  const accessToken =
    window.localStorage.getItem("token") ||
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRJZCI6IldBU1pTNFMiLCJ1c2VySWQiOiJhamF5QGdtYWlsLmNvbSIsInVzZXJOYW1lIjoiQWpheSAgcyIsImlhdCI6MTc2NDEzMTA2MiwiZXhwIjoxNzY0MTU5ODYyfQ.36zvX0ifNADsCc6yzd5OvTrySUMHo30g8-GNsyjcfn0";

  return useQuery({
    queryKey: [key],
    queryFn: async () => {
      const res = await apiInstance({
        method: "GET",
        url,
        headers: {
          Insytsjwt: accessToken,
        },
      });
      return res.data;
    },
    refetchOnWindowFocus: false,
  });
};
